module.exports = __webpack_public_path__ + "img/bf.aa09de8e.jpg";